import { render, staticRenderFns } from "./modal.component.vue?vue&type=template&id=0282f796&scoped=true"
import script from "./modal.component.vue?vue&type=script&lang=js"
export * from "./modal.component.vue?vue&type=script&lang=js"
import style0 from "./modal.component.vue?vue&type=style&index=0&id=0282f796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282f796",
  null
  
)

export default component.exports